import { connect, MapStateToProps } from 'react-redux';
import { Props } from './SearchBar';
import { AppState } from '../../../../types/store';
import {
  getEstimatedGrandTotal,
  getFilterTags,
  getSearchTerm,
  getSelectedTags,
} from '../../../../selectors/facet';

export type StateProps = Pick<
  Props,
  'searchTerm' | 'estTotalTotal' | 'filterTags' | 'selectedTags'
>;
export type DispatchProps = Pick<Props, never>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  AppState
> = state => ({
  estTotalTotal: getEstimatedGrandTotal(state),
  filterTags: getFilterTags(state),
  searchTerm: getSearchTerm(state) || '',
  selectedTags: getSelectedTags(state),
});

export default connect(mapStateToProps);
